import { useEffect } from "react";

/**
 * 滚动锁定：弹窗打开时禁止背景页面滚动（计数式，支持多个弹窗叠加）。
 * 用法：在弹窗组件里 useScrollLock(open)。
 */
let count = 0;
let prev = { body: "", html: "" };

export function useScrollLock(active: boolean) {
  useEffect(() => {
    if (!active) return;
    if (count === 0) {
      prev = { body: document.body.style.overflow, html: document.documentElement.style.overflow };
      document.body.style.overflow = "hidden";
      document.documentElement.style.overflow = "hidden";
    }
    count++;
    return () => {
      count--;
      if (count === 0) {
        document.body.style.overflow = prev.body;
        document.documentElement.style.overflow = prev.html;
      }
    };
  }, [active]);
}

/**
 * 弹窗快捷键：ESC 取消、Enter 提交。
 * Enter 在 textarea 内放行（正常换行）；onSubmit 省略则 Enter 不处理。
 */
export function useModalKeys(active: boolean, opts: { onClose?: () => void; onSubmit?: () => void }) {
  const { onClose, onSubmit } = opts;
  useEffect(() => {
    if (!active) return;
    const onKey = (e: KeyboardEvent) => {
      if (e.key === "Escape") { onClose?.(); return; }
      if (e.key === "Enter" && onSubmit) {
        if ((e.target as HTMLElement)?.tagName === "TEXTAREA") return;
        e.preventDefault();
        onSubmit();
      }
    };
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, [active, onClose, onSubmit]);
}
